import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=1955c95a&"
import script from "./AppToolbar.vue?vue&type=script&lang=js&"
export * from "./AppToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/johnbenedictc.legaspi/Documents/Consultancy/ideaforma-master/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VToolbar,VToolbarTitle})
